import styled, { css } from 'styled-components'

export const InputGroup = styled.div<{ $sizes?: number[] }>`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  margin-bottom: ${({ theme }) => theme.spacing.xs}rem;

  & > * {
    margin: 0;
  }

  // Flex box sizes from sizes prop
  ${({ $sizes }) =>
    $sizes &&
    $sizes.map(
      (size, index) => css`
        & > :nth-child(${index + 1}) {
          flex: ${size};
        }
      `
    )}
`
